import { useEffect, useState } from "react";
import { FiPhone } from "react-icons/fi";
import { GoPerson } from "react-icons/go";
import { LuBuilding2 } from "react-icons/lu";
import { TfiReceipt } from "react-icons/tfi";
import { MdOutlineAlternateEmail, MdOutlineCurrencyRupee } from "react-icons/md";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { validateFields, commonOnChange, commonOnSelect, isValidObject, showToast } from "../../../utils";
import { addCompany, getCompanies, updateCompany } from "../../../actions/companies";
import { useDispatch } from "react-redux";
import { dropdownDefaultList } from "../../../constants";
import CountryStateCitySelect from "../../../Common/CountryDropDown";

const AddCompany = ({ show, hideModal, companyData }) => {
    const [details, setDetails] = useState({
        request: false,
        company: "",
        companyId: "",
        gstType: "",
        gstNo: "",
        name: "",
        mobileNo: "",
        email: "",
        city: "",
        state: "",
        country: "",
        fullAddress: "",
        amount: 0,
        companyErr: null,
        gstTypeErr: null,
        gstNoErr: null,
        nameErr: null,
        mobileNoErr: null,
        emailErr: null,
        cityErr: null,
        stateErr: null,
        countryErr: null,
        fullAddressErr: null,
    });
    const dispatch = useDispatch();
    
    const { request, company, gstType, gstNo, name, mobileNo, email, city, state, country, fullAddress, companyErr, gstTypeErr, gstNoErr, nameErr, mobileNoErr, emailErr, cityErr, stateErr, countryErr, fullAddressErr, amount } = details;

    const onChangeHandler = (event) => commonOnChange(event, setDetails);
    const onSelectHandler = (event) => commonOnSelect(event, setDetails);
    const countryHandler = (details) => {
        setDetails(prev => ({ ...prev, ...details }))
    }

    const submit = () => {
        const obj = gstType == "GST" ? { gstNoErr: [gstNo, "text"] } : {}
        validateFields(
            {
                companyErr: [company, "text"],
                gstTypeErr: [gstType, "text"],
                ...obj,
                // nameErr: [name, "text"],
                mobileNoErr: [mobileNo, "phone"],
                // emailErr: [email, "email"],
                cityErr: [city, "text"],
                stateErr: [state, "text"],
                countryErr: [country, "text"],
                fullAddressErr: [fullAddress, "text"]
            },
            setDetails,
            () => {
                setDetails(prev => ({ ...prev, request: true }));
                const obj = {
                    companyName: company,
                    gstNumber: gstNo || null,
                    contactPerson: name,
                    city,
                    email,
                    state,
                    country,
                    gstType,
                    mobileNo,
                    address: fullAddress
                  }
                  if(companyData?.companyId) obj["outstandingAmount"] = amount;

                const action = companyData?.companyId ? () => updateCompany(obj, companyData?.companyId) : () => addCompany(obj)
                action().then(response => {
                    if (response?.data?.data) {
                        showToast(response?.data?.message ?? "", "success");
                        dispatch(getCompanies());
                        setTimeout(hideModal, 2000);
                    }
                }).catch(ex => {
                    showToast(ex.response?.data?.message ?? "", "error");
                }).finally(() => {
                    setDetails(prev => ({ ...prev, request: false }));
                })
            }
        )
    }

    useEffect(() => {
        if (isValidObject(companyData)) {
            setDetails(prev => ({
                ...prev,
                company: companyData?.companyName ?? "",
                companyId: companyData?.companyId ?? "",
                gstType: companyData?.gstType ?? "",
                gstNo: companyData?.gstNumber ?? "",
                name: companyData?.contactPerson ?? "",
                mobileNo: companyData?.mobileNo ?? "",
                email: companyData?.email ?? "",
                city: companyData?.city ?? "",
                state: companyData?.state ?? "",
                country: companyData?.country ?? "",
                amount: companyData?.opening_balance ?? 0,
                fullAddress: companyData?.address ?? ""
            }))
        }
    }, [companyData])

    return <ModalElement height={"100vh"} FooterComponent={<div className="submit-btn text-center my-2">
        <ButtonElement loading={request} text={"Submit"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" />
    </div>} size="lg" show={show} title={`${companyData?.companyId ? "Edit" : "Add"} Company`} onHide={hideModal}>
        <div className="add-company text-start">
            <div className="company-details mb-3">
                <h5 className="mb-3">Company Details</h5>
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Company Name"}
                            placeholder={"Enter Company Name"}
                            name={"company"}
                            value={company}
                            error={companyErr}
                            icon={<LuBuilding2 size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <SearchableDropdown
                            label={"GST type"}
                            placeholder={"Select GST Type"}
                            value={gstType}
                            error={gstTypeErr}
                            options={dropdownDefaultList.gstStatus}
                            onSelect={(value) => onSelectHandler({ target: { name: "gstType", value } })}
                        />
                    </div>
                    {gstType == "GST" ? <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"GST Number"}
                            placeholder={"Enter GST Number"}
                            name={"gstNo"}
                            value={gstNo}
                            error={gstNoErr}
                            icon={<TfiReceipt size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div> : null}
                    {companyData?.companyId ? <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            type="number"
                            label={`Opening Amount`}
                            placeholder={`Enter Opening Amount`}
                            name={"amount"}
                            value={amount}
                            error={false}
                            icon={<MdOutlineCurrencyRupee size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div> : null}
                </div>
            </div>
            <div className="company-person-details mb-3">
                <h5 className="mb-3">Contact Person Details</h5>
                <div className="row">
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            isRequired={false}
                            label={"Name"}
                            placeholder={"Enter Name"}
                            name={"name"}
                            value={name}
                            error={nameErr}
                            icon={<GoPerson size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            label={"Mobile No"}
                            placeholder={"Enter Mobile No"}
                            name={"mobileNo"}
                            value={mobileNo}
                            maxLen="10"
                            error={mobileNoErr}
                            icon={<FiPhone size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                    <div className="col-lg-4 col-md-6 mb-2">
                        <InputElement
                            isRequired={false}
                            label={"Email ID"}
                            placeholder={"Enter Email Id"}
                            name={"email"}
                            value={email}
                            error={emailErr}
                            icon={<MdOutlineAlternateEmail size={20} />}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div>
            <div className="company-address mb-3">
                <h5 className="mb-3">Address Details</h5>
                <div className="row">
                    <CountryStateCitySelect {...{ onSelectHandler: countryHandler, showCountry: true, city, state, country, countryErr, stateErr, cityErr }} />
                    <div className="col-12 mt-2">
                        <InputElement
                            isTextArea={true}
                            label={"Full Address"}
                            placeholder={"Enter Full Address"}
                            name={"fullAddress"}
                            value={fullAddress}
                            error={fullAddressErr}
                            onChange={onChangeHandler}
                        />
                    </div>
                </div>
            </div>
        </div>
    </ModalElement>
}

export default AddCompany;